import React from 'react';
import { Link } from 'react-router-dom';
import './Admin.css';

export default function AdminDashboard({ stats }) {
  const cards = [
    { num: stats.totalProducts || 0, label: 'Total Products', link: '/admin/products' },
    { num: stats.totalUsers || 0, label: 'Registered Users', link: '/admin/users' },
    { num: stats.pendingUsers || 0, label: 'Pending Approvals', link: '/admin/users', alert: stats.pendingUsers > 0 },
    { num: stats.totalOrders || 0, label: 'Total Orders', link: '/admin/orders' },
    { num: stats.pendingOrders || 0, label: 'Pending Orders', link: '/admin/orders', alert: stats.pendingOrders > 0 },
    { num: stats.unreadMessages || 0, label: 'Unread Messages', link: '/admin/messages', alert: stats.unreadMessages > 0 },
  ];

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <p style={{fontSize:'12px',letterSpacing:'2px',textTransform:'uppercase',color:'var(--terracotta)',marginBottom:'8px'}}>Admin Panel</p>
          <h1 className="admin-page-title">Dashboard</h1>
        </div>
        <Link to="/admin/products" className="btn-terracotta btn-sm">+ Add Product</Link>
      </div>

      <div className="stat-cards">
        {cards.map((c, i) => (
          <Link key={i} to={c.link} className={`stat-card ${c.alert ? 'stat-card-alert' : ''}`} style={{textDecoration:'none'}}>
            <div className="stat-card-num">{c.num}</div>
            <div className="stat-card-label">{c.label}</div>
          </Link>
        ))}
      </div>

      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'24px'}}>
        <div style={{background:'var(--white)',border:'1px solid var(--gray-light)',padding:'28px'}}>
          <h3 style={{fontSize:'18px',marginBottom:'16px'}}>Quick Actions</h3>
          <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
            <Link to="/admin/products" className="admin-btn admin-btn-primary" style={{textAlign:'center',padding:'12px'}}>Add New Product</Link>
            <Link to="/admin/users" className="admin-btn admin-btn-edit" style={{textAlign:'center',padding:'12px'}}>Manage User Approvals</Link>
            <Link to="/admin/orders" className="admin-btn admin-btn-approve" style={{textAlign:'center',padding:'12px'}}>View New Orders</Link>
            <Link to="/admin/messages" className="admin-btn" style={{textAlign:'center',padding:'12px',background:'var(--cream-dark)'}}>Check Messages</Link>
          </div>
        </div>
        <div style={{background:'var(--white)',border:'1px solid var(--gray-light)',padding:'28px'}}>
          <h3 style={{fontSize:'18px',marginBottom:'16px'}}>About This Panel</h3>
          <div style={{fontSize:'13px',color:'var(--gray)',lineHeight:'1.8',display:'flex',flexDirection:'column',gap:'10px'}}>
            <p>• <strong>Products</strong> — Add, edit, delete products. Upload images. Set prices, sizes, colours and minimum order quantities.</p>
            <p>• <strong>Users</strong> — Approve or reject buyer registrations. Revoke buyer access at any time.</p>
            <p>• <strong>Orders</strong> — View all orders. Update status from Pending → Confirmed → Dispatched.</p>
            <p>• <strong>Settings</strong> — Edit your contact details, hero text, and about text directly.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
